import { query } from '../../../../../utils/helpers/data-query';
import {
    ComponentSearchMap,
    ComponentFilterMap,
    filterSubcomponentsByStatus,
    filterSubcomponentsByRating,
    filterSubcomponentsByOwner,
    filterSubcomponentsByFrequency,
} from './component-query-maps';

export const FilterComponents = ({ components, dataFilters }) => {
    if (!Array.isArray(components) || components.length === 0) {
        return [];
    }

    if (!dataFilters) {
        return components;
    }

    const {
        searchTerm,
        searchOption,
        componentStatusIds,
        statusId = [],
        ratingId = [],
        ownerIds = [],
        frequencyIds = [],
    } = dataFilters;

    const hasSubcomponentFilters =
        (Array.isArray(statusId) && statusId.length > 0) ||
        (Array.isArray(ratingId) && ratingId.length > 0) ||
        (Array.isArray(ownerIds) && ownerIds.length > 0) ||
        (Array.isArray(frequencyIds) && frequencyIds.length > 0);

    let filtered = query(components)
        .search(searchTerm, searchOption, ComponentSearchMap)
        .filter({ componentStatusIds }, ComponentFilterMap)
        .toArray();

    if (hasSubcomponentFilters) {
        filtered = filtered
            .map((component) => {
                let filteredSubcomponents = component.subcomponents;

                filteredSubcomponents = filterSubcomponentsByStatus(
                    filteredSubcomponents,
                    statusId
                );

                filteredSubcomponents = filterSubcomponentsByRating(
                    filteredSubcomponents,
                    ratingId
                );

                filteredSubcomponents = filterSubcomponentsByOwner(filteredSubcomponents, ownerIds);

                filteredSubcomponents = filterSubcomponentsByFrequency(
                    filteredSubcomponents,
                    frequencyIds
                );

                return {
                    ...component,
                    originalSubcomponents: component.subcomponents,
                    subcomponents: filteredSubcomponents,
                };
            })
            .filter((component) => component.subcomponents.length > 0);
    }

    return filtered;
};
